import * as apiTo from '@api/api-routes'

export default {
  namespaced: true,

  state() {
    return {
      titleList: null
    }
  },

  mutations: {
    setTitleList: (state, payload) => (state.titleList = payload),
    updateTitleList: (state, payload) => (state.titleList = payload),
    increasePublicationsCount: state => state.titleList.publications_count++,
    decreasePublicationsCount: state => state.titleList.publications_count--
  },

  actions: {
    getAndSetTitleList({ commit }, id) {
      apiTo.getTitleList(id).then(({ data }) => commit('setTitleList', data.result))
    },

    updateTitleList({ commit }, { id, payload }) {
      apiTo.updateTitleList(id, payload).then(({ data }) => commit('updateTitleList', data.result))
    }
  }
}
